import bdServices from '../bd-services'
var FormData = require('form-data')

const sca_tuxpanServices = {}

sca_tuxpanServices.getLlenaderas = async function (c) {
  let formData = new FormData()
  formData.append('c', c)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/tpa/sca/llenaderas.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.getEsferas = async function () {
  const data = await bdServices.get('/servidores/tpa/sca/esferas.php')
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getPatinTPA = async function () {
  const data = await bdServices.get('/servidores/tpa/sca/patines.php')
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getDocumentados = async function (fecha) {
  const data = await bdServices.get(`/servidores/tpa/sca/getDocumentados.php?f=${fecha}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getDocumentados_Comercializadora = async function (fechaI, fechaF, hash) {
  let formData = new FormData()
  formData.append('fi', fechaI)
  formData.append('ff', fechaF)
  formData.append('g', hash)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/tpa/sca/data/getEmbarques_Destinos_Comer.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.getDocumentados_Grupo = async function (fecha, hash) {
  let formData = new FormData()
  formData.append('f', fecha)
  formData.append('g', hash)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/tpa/sca/getEmbarques_Destinos_Grupos.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.getDocumentados_SubGrupo = async function (fechaI, fechaF, hash) {
  let formData = new FormData()
  formData.append('fi', fechaI)
  formData.append('ff', fechaF)
  formData.append('g', hash)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/tpa/sca/data/getEmbarques_Destinos_SubGrupo.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.getDestinos = async function () {
  const data = await bdServices.get(`/servidores/tpa/destinatarios.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.updateDestino = async function (id, nombreDestino, direccion, clave, telefono) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('nombreDestino', nombreDestino)
  formData.append('direccionDestino', direccion)
  formData.append('clave', clave)
  formData.append('telefono', telefono)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/updateDestino.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.updatePermisoEditar = async function (id, status, accion) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('status', status)
  formData.append('accion', accion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/updatePermiso.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.getDestinos_All = async function () {
  const data = await bdServices.get(`/servidores/tpa/sca/data/destinarios.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getPorteadores = async function () {
  const data = await bdServices.get('/servidores/tpa/porteadores.php')
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.updatePorteador = async function (id, nombrePorteador, clavePorteador, rfcPorteador) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('nombrePorteador', nombrePorteador)
  formData.append('clavePorteador', clavePorteador)
  formData.append('rfcPorteador', rfcPorteador)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/updatePorteador.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.getOperadores = async function () {
  const data = await bdServices.get('/servidores/tpa/operadores.php')
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.updateOperador = async function (id, nombre, identificacion, telefono) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('nombreOperador', nombre)
  formData.append('identificacionOperador', identificacion)
  formData.append('telefonoOperador', telefono)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/updateOperador.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.getAutotanques = async function () {
  const data = await bdServices.get('/servidores/tpa/autotanques.php')
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getValorUnitario = async function () {
  const data = await bdServices.get('/servidores/tpa/getValorUnitario.php')
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getPG_cargados = async function () {
  const data = await bdServices.get('/servidores/tpa/getPG_cargados.php')
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getCargas = async function (fecha) {
  const data = await bdServices.get(`/servidores/tpa/sca/getCargas.php?f=${fecha}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getEmbarque = async function (id) {
  const data = await bdServices.get(`/servidores/tpa/getEmbarque.php?id=${id}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.buscarId = async function () {
  const data = await bdServices.get('/servidores/tpa/sca/buscarId.php')
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.documentar = async function (noEmbarque, fecha, expedidor, claveExpedidor, direccionOrigen, telefonoExpedido, iddestinatario, nombreDestinatario, claveDestino, direccionDestino, telefonoDestino, idporteador, nombrePorteador, clavePorteador, rfc, placas, operador, compania, grupo, subgrupo, valorCarga, valorUnitario, magnatel, producto, datosAdicionales, tiempoCarga, personaEmbarque, remitente, pg, volumen, masa, presion, presionTanque, fechaSalida, fechaJornada, numeroDeEmbarque, id_user, densidad, contenedorLitros) {
  let formData = new FormData()
  formData.append('noEmbarque', noEmbarque)
  formData.append('fecha', fecha)
  formData.append('expedidor', expedidor)
  formData.append('claveExpedidor', claveExpedidor)
  formData.append('direccionOrigen', direccionOrigen)
  formData.append('telefonoExpedido', telefonoExpedido)
  formData.append('iddestinatario', iddestinatario)
  formData.append('nombreDestinatario', nombreDestinatario)
  formData.append('claveDestino', claveDestino)
  formData.append('direccionDestino', direccionDestino)
  formData.append('telefonoDestino', telefonoDestino)
  formData.append('idporteador', idporteador)
  formData.append('nombrePorteador', nombrePorteador)
  formData.append('clavePorteador', clavePorteador)
  formData.append('rfc', rfc)
  formData.append('placas', placas)
  formData.append('operador', operador)
  formData.append('compania', compania)
  formData.append('grupo', grupo)
  formData.append('subgrupo', subgrupo)
  formData.append('valorCarga', valorCarga)
  formData.append('valorUnitario', valorUnitario)
  formData.append('magnatel', magnatel)
  formData.append('producto', producto)
  formData.append('datosAdicionales', datosAdicionales)
  formData.append('tiempoCarga', tiempoCarga)
  formData.append('personaEmbarque', personaEmbarque)
  formData.append('remitente', remitente)
  formData.append('pg', pg)
  formData.append('volumen', volumen)
  formData.append('masa', masa)
  formData.append('presion', presion)
  formData.append('presionTanque', presionTanque)
  formData.append('fechaSalida', fechaSalida)
  formData.append('fechaJornada', fechaJornada)
  formData.append('numeroDeEmbarque', numeroDeEmbarque)
  formData.append('id_user', id_user)
  formData.append('densidad', densidad)
  formData.append('contenedorLitros', contenedorLitros)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/addEmbarque.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.updateLlenado = async function (idLlenado, idEmb, fechaEntrada) {
  let formData = new FormData()
  formData.append('iLlen', idLlenado)
  formData.append('iEmb', idEmb)
  formData.append('fE', fechaEntrada)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/updateLlenado.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.updateRecepcion_pg = async function (id, fechaHora, pg, embarque) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('fechaHora', fechaHora)
  formData.append('pg', pg)
  formData.append('embarque', embarque)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/updateRec_pg.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.getAcceso_pg = async function (pg) {
  const data = await bdServices.get(`/servidores/tpa/sca/getAcceso_pg.php?pg=${pg}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getLastPorteador = async function (pg) {
  let formData = new FormData()
  formData.append('pg', pg)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/getLastPorteador.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.cambiarNombrePG = async function (idEmb, newName) {
  let formData = new FormData()
  formData.append('idEmb', idEmb)
  formData.append('newName', newName)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/cambiarNombrePG.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.updateCartaPorte = async function (id, iddestinatario, nombreDestinatario, claveDestino, direccionDestino, telefonoDestino, idporteador, nombrePorteador, clavePorteador, rfc, placas, operador, compania, grupo, subgrupo, magnatel, datosAdicionales, personaEmbarque, presionTanque, valorCarga, valorUnitario) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('iddestinatario', iddestinatario)
  formData.append('nombreDestinatario', nombreDestinatario)
  formData.append('claveDestino', claveDestino)
  formData.append('direccionDestino', direccionDestino)
  formData.append('telefonoDestino', telefonoDestino)
  formData.append('idporteador', idporteador)
  formData.append('nombrePorteador', nombrePorteador)
  formData.append('clavePorteador', clavePorteador)
  formData.append('rfc', rfc)
  formData.append('placas', placas)
  formData.append('operador', operador)
  formData.append('compania', compania)
  formData.append('grupo', grupo)
  formData.append('subgrupo', subgrupo)
  formData.append('magnatel', magnatel)
  formData.append('datosAdicionales', datosAdicionales)
  formData.append('personaEmbarque', personaEmbarque)
  formData.append('presionTanque', presionTanque)
  formData.append('valorCarga', valorCarga)
  formData.append('valorUnitario', valorUnitario)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/updateEmbarque.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.addEdicion = async function (idEmbarque, fecha, usuario, cambios) {
  let formData = new FormData()
  formData.append('idEmbarque', idEmbarque)
  formData.append('fecha', fecha)
  formData.append('usuario', usuario)
  formData.append('cambios', cambios)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/addEdicion.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.updateMotivo = async function (motivo, embarque) {
  let formData = new FormData()
  formData.append('motivo', motivo)
  formData.append('embarque', embarque)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/updateMotivo.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.createExcel_rif = async function(fecha, cliente) {
  let formData = new FormData()
  formData.append('fecha', fecha)

  const uri = cliente === 'normal' ? '/reportesApp/server/excel/RDC_tpa.php' : '/reportesApp/server/excel/RDC_tpa_Mov.php'

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: uri,
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.createExcel_rif_mensual = async function(fechaI,fechaF, cliente) {
  let formData = new FormData()
  formData.append('fechaI', fechaI)
  formData.append('fechaF', fechaF)

  const uri = cliente === 'normal' ? '/reportesApp/server/excel/RDC_tpa_mensual.php' : '/reportesApp/server/excel/RDC_tpa_Mov_mensual.php'

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: uri,
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.createExcel_rdc_mensual = async function(fechaI,fechaF, reporte) {
  let formData = new FormData()
  formData.append('fechaI', fechaI)
  formData.append('fechaF', fechaF)
  formData.append('reporte', reporte)

  const uri = '/reportesApp/server/excel/RDC_tpa_mensual_vol.php'
  console.log(uri);
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: uri,
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}
sca_tuxpanServices.addPorteador = async function (nombre, clave, rfc) {
  let formData = new FormData()
  formData.append('nombre', nombre)
  formData.append('clave', clave)
  formData.append('rfc', rfc)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/addPorteador.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.addDestinos = async function (nombre, direccion, clave, telefono) {
  let formData = new FormData()
  formData.append('nombre', nombre)
  formData.append('direccion', direccion)
  formData.append('clave', clave)
  formData.append('telefono', telefono)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/addDestino.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.addOperador = async function (id, nombre, identificacion, telefono) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('nombre', nombre)
  formData.append('identificacion', identificacion)
  formData.append('telefono', telefono)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/addOperador.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.addPg = async function (pg, capacidad, id_cre, placa, fechaMod) {
  let formData = new FormData()
  formData.append('pg', pg)
  formData.append('capacidad', capacidad)
  formData.append('id_cre', id_cre)
  formData.append('placa', placa)
  formData.append('fechaMod', fechaMod)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/addPg.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.updateDolar = async function (newDolar, newValorU) {
  let formData = new FormData()
  formData.append('newD', newDolar)
  formData.append('newVu', newValorU)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/updateDolar.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.getBitacora = async function (fechaI, fechaF) {
  const data = await bdServices.get(`/servidores/tpa/sca/getBitacora.php?fI=${fechaI}&fF=${fechaF}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.createExcel_bascula = async function(fecha, cliente) {
  var currentUrl = window.location.hostname
  let formData = new FormData()
  formData.append('fecha', fecha)

  let uri = ''
  switch(cliente){
    case "normal":
      uri = '/reportesApp/server/excel/bascula_tpa.php';
      break;
    case "mov":
      uri = '/reportesApp/server/excel/bascula_tpa_Mov.php';
      break;
    case "pemex":
      uri = '/reportesApp/server/excel/bascula_tpa_Pem.php';
      break;
  }

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: uri,
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

sca_tuxpanServices.borrarArchivo = async function(nameFile) {
  const data = await bdServices.get(`/reportesApp/server/excel/borrarArchivo.php?nameFile=${nameFile}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getSubgrupos = async function () {
  const data = await bdServices.get(`/servidores/tpa/sca/getSubgrupos.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getDocumentadosOld = async function (fechaI, fechaF) {
  const data = await bdServices.get(`/SCA_Tuxpan/data/getEmbarques_Destinos.php?fi=${fechaI}&ff=${fechaF}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getSubgrupos_nominaciones = async function (fecha) {
  let formData = new FormData()
  formData.append('f', fecha)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/nominaciones/getSubgrupos_nominaciones.php',
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.obtenerConfiguracion = async function () {
  const data = await bdServices.get(`/servidores/tpa/sca/getConfiguracion.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.obtenerCompaniasDocumentadas = async function (fecha) {
  const data = await bdServices.get(`/servidores/tpa/sca/getDocumentadosCompanias.php?fecha=${fecha}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.obtenerSubgruposDocumentados = async function (fecha) {
  const data = await bdServices.get(`/servidores/tpa/sca/getDocumentadosSubgrupos.php?fecha=${fecha}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getDocumentados_pg = async function (pg) {
  const data = await bdServices.get(`/servidores/tpa/sca/getDocumentados_pg.php?pg=${pg}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getEmpresasTPA = async function () {
  const data = await bdServices.get(`/servidores/tpa/sca/getEmpresas.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getGruposTPA = async function () {
  const data = await bdServices.get(`/servidores/tpa/sca/getGrupos.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getSubgruposTPA = async function () {
  const data = await bdServices.get(`/servidores/tpa/sca/getSubgrupos.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.addEdicion = async function (idEmbarque, fecha, usuario, cambios, motivos) {
  let formData = new FormData()
  formData.append('idEmbarque', idEmbarque)
  formData.append('fecha', fecha)
  formData.append('usuario', usuario)
  formData.append('cambios', cambios)
  formData.append('motivos', motivos)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/addMovimientoAccesos.php'
  }
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
}

sca_tuxpanServices.getCargasBusqueda = async function (pg) {
  const data = await bdServices.get(`/servidores/tpa/sca/getCargasByPg.php?pg=${pg}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

sca_tuxpanServices.getSolicitudCargasPendientes = async function () {
  let formData = new FormData()
  formData.append('key', '14yh9GacQO8BtkkwxTZCC34')

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/solicitudes/index.php'
  }
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
}

sca_tuxpanServices.insertSolicitudCargasPendientes = async function (id_usuario) {
  let formData = new FormData()
  formData.append('key', '14yh9GacQO8BtkkwxTZCC34')
  formData.append('id_usuario', id_usuario)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/solicitudes/insert.php'
  }
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
}

sca_tuxpanServices.updateSolicitudCargasPendientes = async function (id_solicitud) {
  let formData = new FormData()
  formData.append('key', '14yh9GacQO8BtkkwxTZCC34')
  formData.append('id', id_solicitud)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/solicitudes/update.php'
  }
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
}

export default sca_tuxpanServices



// WEBPACK FOOTER //
// ./src/services/sca/tpa.js